<template>
  <div>
    <v-app-bar app clipped-right class="personal-shadow" color="#3861ad" dark>
      <template v-slot:image>
        <v-img
          gradient="to top right, rgba(19,84,122,.8), rgba(128,208,199,.8)"
        ></v-img>
      </template>

      <v-app-bar-nav-icon @click="hideNav"></v-app-bar-nav-icon>
      <!-- <v-toolbar-title>Toolbar</v-toolbar-title> -->
      <v-spacer></v-spacer>

      <v-tooltip>
        <template v-slot:activator="{ on, attrs }">
          <v-container>
            <v-system-bar color="#3861ad" dark v-bind="attrs" v-on="on">
              <div class="banner-text-wrapper">
                <span class="banner-text">Salario Mínimo 2025 $ 1.423.500 -Uvt 2025: $49.799 -Sanción Mínima Dian:$498.000</span>
              </div>
            </v-system-bar>
          </v-container>
        </template>
      </v-tooltip>

      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="soporte" v-bind="attrs" v-on="on">
            <v-icon color="orange">mdi-account-network</v-icon>
          </v-btn>
        </template>
        <span>Generar Pin de Asistencia Remota</span>
      </v-tooltip> -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="actualizar" v-bind="attrs" v-on="on">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Actualizar Plataforma</span>
      </v-tooltip>

      <v-tooltip bottom v-if="data_msg">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="actualizar" v-bind="attrs" v-on="on">
            <v-badge
              :content="messages"
              :value="messages"
              color="green"
              overlap
            >
              <v-icon> mdi-bell-outline </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Notificaciones</span>
      </v-tooltip>

      <div>
        <v-menu
          v-model="menu"
          :close-on-content-click="true"
          :nudge-width="100"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-list dense width="250" max-height="64" color="#3861ad">
              <!-- <v-list dense width="250" max-height="64" color="blue darken-4">               -->
              <v-list-item link v-on="on">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">
                    {{ user.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption font-weight-regular">
                    {{ user.identificaion }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-card elevation="0">
            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-img :src="user.img" height="45" width="45"></v-img>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ user.nombre }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    user.identificaion
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <!-- <v-list-item-group> -->
              <v-list-item dense link @click="modal_clave.estado = true">
                <v-list-item-icon>
                  <v-icon>mdi-account-edit-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Actualizar Contraseña</v-list-item-title>
              </v-list-item>
              <v-list-item dense link to="/menuconta" v-if="menuconta">
                <v-list-item-icon>
                  <v-icon>mdi-file-tree</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Panel Contador</v-list-item-title>
              </v-list-item>
              <v-list-item dense inactive :ripple="false">
                <v-list-item-content>
                  <v-btn
                    depressed
                    text
                    outlined
                    color="orange darken-3"
                    @click="logout"
                    >Cerrar sesión</v-btn
                  >
                </v-list-item-content>
              </v-list-item>
              <!-- </v-list-item-group> -->
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>

    <v-dialog v-model="modal_clave.estado" persistent max-width="400">
      <v-card>
        <v-card-title class="headline"> Actualizar contraseña </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                label="Contraseña actual"
                hide-details
                clearable
                type="password"
                v-model="modal_clave.clave_actual"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Nueva contraseña"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                outlined
                clearable
                v-model="modal_clave.clave_nueva"
                @click:append="show2 = !show2"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            depressed
            @click="
              modal_clave.estado = false;
              modal_clave.clave_actual = null;
              modal_clave.clave_nueva = null;
            "
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            class="white--text"
            depressed
            @click="actualizar_clave"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.estado"
      :color="snackbar.color"
      :timeout="10000"
      bottom
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          @click="snackbar.estado = false"
          icon
          class="white--text"
          v-bind="attrs"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-row>
      <v-col cols="12" md="6">
        <v-dialog transition="dialog-top-transition" width="auto">
          <template v-slot:activator="{ props: activatorProps }">
            <v-btn
              v-bind="activatorProps"
              text="Transition from Top"
              block
            ></v-btn>
          </template>
          <template v-slot:default="{ isActive }">
            <v-card>
              <v-toolbar title="Opening from the Top"></v-toolbar>

              <v-card-text class="text-h2 pa-12"> Hello world! </v-card-text>

              <v-card-actions class="justify-end">
                <v-btn text="Close" @click="isActive.value = false"></v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// const fb = require("../firebaseConfig.js");
export default {
  name: "appBar",
  data() {
    return {
      show2: false,
      drawer: true,
      menu: false,
      showBanner: true,
      data_msg: false,
      messages: [],
      user: {
        sesion: null,
        identificaion: null,
        nombre: null,
        img: null,
      },
      menuconta: false,
      snackbar: {
        estado: false,
      },
      modal_clave: {
        estado: false,
        clave_actual: null,
        clave_nueva: null,
      },
    };
  },
  created() {
    if (sessionStorage.Sesion_anterior) this.menuconta = true;
    this.user.sesion = sessionStorage.Sesion;
    this.user.identificaion = `${parseFloat(this.user.sesion.substr(15, 15))}`;
    this.user.nombre = `${sessionStorage.User}` || "N/A";
    this.user.img =
      "http://80.211.145.179/datos/image/users/" +
      this.user.identificaion +
      ".png";
  },
  methods: {
    actualizar_clave() {
      this.show2 = false;
      let clave_actual = this.modal_clave.clave_actual;
      let clave_nueva = this.modal_clave.clave_nueva;

      if (!clave_actual) {
        this.msj("Debe ingresar la contraseña actual");
      } else if (!clave_nueva) {
        this.msj("Debe ingresar la contraseña nueva");
      } else {
        let data = [sessionStorage.Sesion, clave_actual, clave_nueva];
        this.postData({
          url: "financiero/dlls/login9.dll",
          data: data.join("|") + "|",
          method: "",
        })
          .then((data) => {
            this.msj("Contraseña actualizada correctamente.", "green");
            this.modal_clave.estado = false;
            this.modal_clave.clave_actual = null;
            this.modal_clave.clave_nueva = null;
          })
          .catch((err) => {
            this.msj("Ha ocurrido un error: " + err.Mensaje);
          });
      }
    },
    actualizar() {
      location.reload();
    },
    soporte() {
      window.open("https://remotedesktop.google.com/support");
    },
    hideNav() {
      this.$emit("toggleNav", (this.drawer = !this.drawer));
    },
    logout() {
      let ruta = null;
      this.cerrar_sesion();
      let data_auth = sessionStorage.data_auth
        ? JSON.parse(atob(sessionStorage.data_auth))
        : false;
      if (!data_auth) {
        ruta = "/";
      } else if (data_auth && data_auth?.modulo === "rc")
        ruta = { name: "loginrc" };
      else if (data_auth && data_auth?.modulo === "tr")
        ruta = { name: "logintr" };
      else if (data_auth && data_auth?.modulo === "pr")
        ruta = { name: "loginpr" };
      // else if (data_auth && data_auth?.modulo === "resmed")
      //   ruta = { name: "loginresmedicos" };

      sessionStorage.clear();
      this.$router.push(ruta);
    },

    cerrar_sesion() {
      let data = [sessionStorage.Sesion];
      this.postData({
        url: "financiero/dlls/loginout.dll",
        data: data.join("|") + "|",
        method: "",
      })
        .then((data) => {
          console.log(data);
        })
        .catch((err) => {
          this.msj("Ha ocurrido un error: " + err.Mensaje);
        });
    },

    msj(text, color) {
      this.snackbar.estado = true;
      this.snackbar.text = text;
      this.snackbar.color = color ? `${color} darken-2` : "red darken-3";
    },
  },
};
</script>

<style scoped>
.banner-text-wrapper {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.banner-text {
  display: inline-block;
  padding-left: 100%;
  animation: scroll-text 20s linear infinite;
}

@keyframes scroll-text {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>